import { Language } from 'ha/i18n';
import { getCode } from './language';
import { Languages } from '../types';

const initialState = [
  { code: Language.en, localisedText: 'English' },
  { code: Language.fr, localisedText: 'Français' },
  { code: Language.de, localisedText: 'Deutsch' },
  { code: Language.es, localisedText: 'Español' },
  { code: Language.it, localisedText: 'Italiano' },
  { code: Language.nl, localisedText: 'Nederlands' },
  { code: Language.pt, localisedText: 'Português' },
  { code: Language.zh, localisedText: '中文' },
];

export default function availableLanguages(state: Languages = initialState) {
  return state;
}

export const getAvailableLanguages = (state: Languages) => state;

export const isLanguageAvailable = (state: Languages, lang: Language) =>
  state.map(getCode).includes(lang);
